<template>
    <div class="rotator testimonials-rotator" :style="'height: ' + rotatorHeight + 'px;'">
        <div class="slide testimonial"
			:class="isActiveClass(index)"
            v-for="(testimonial, index) in testimonials" 
            :key="'testimonial-' + index">
			<img 
				v-if="testimonial.image" 
				class="testimonial__img"
				:src="testimonial.image" 
				:alt="'Photo of ' + testimonial.author">
			<blockquote class="testimonial__quote">
				<icon-quotes class="testimonial__icon-quotes" />
				<p class="testimonial__text">{{ testimonial.quote }}</p>
				<cite v-if="testimonial.author" class="testimonial__cite">{{ testimonial.author }}</cite>
			</blockquote>
        </div>
        <div class="testimonial__square bg-primary">
            <button class="testimonial__button button-arrow-right" @click.prevent="showNext">
                <svg class="icon-arrow-right" x="0px" y="0px" viewBox="0 0 57 101.7">
                    <polygon style="fill:currentColor;" points="6.1,0 0,6.1 44.7,50.9 0,95.6 6.1,101.7 57,50.9 "/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import RotatorBase from './RotatorBase';
import IconQuotes from './Icons/IconQuotes';
import axios from 'axios';

export default {
	extends: RotatorBase,
	 
    components: {
        IconQuotes,
	},

	props: { types: { type: Array, default: () => []} },
	
    data() {
        return {
            testimonials: [],
            activeSlide: 0,
        }
    },

    methods: {
        showNext() {
            this.goToNextSlide(this.testimonials);
		},
		
		filterTestimonials() {

			this.testimonials = this.testimonials.filter( testimonial => {

				for ( let i=0; i < testimonial.type.length; i++ ) {
					if ( this.types.includes( testimonial.type[i] ) ) {
						return true
					}
				}
				return false

			})
		}
    },

    created() {
		// console.log(this.types)
    },

    mounted() {
		axios.get('/api/collections/testimonials/entries')
			.then( response => {
				this.testimonials = response.data.data
				this.filterTestimonials()
			})
	},
}
</script>